'use client';
import { useEffect, useRef, useState } from 'react';

/** Native seeking/range playback shares the persistent player's media-focus listener. */
export function PodcastAudio({ src, title }: { src: string; title: string }) {
  const audio = useRef<HTMLAudioElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { const element = audio.current; return () => element?.pause(); }, []);
  return <div className="mt-5"><audio ref={audio} className="w-full" aria-label={`Listen to ${title}`} controls preload="none" src={src} onError={() => setFailed(true)} onPlaying={() => setFailed(false)} />{failed && <p role="alert" className="mt-2 text-sm">Audio is unavailable or the connection was interrupted. <button type="button" className="underline" onClick={() => { setFailed(false); audio.current?.load(); }}>Retry audio</button> or reload the episode for its latest version.</p>}</div>;
}
